import { render, staticRenderFns } from "./ContactContent.vue?vue&type=template&id=65dd8226&"
import script from "./ContactContent.vue?vue&type=script&lang=js&"
export * from "./ContactContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports